import { Injectable } from '@angular/core';
import { CommonConstants } from '../utilities/commonConstants';
import { SessionHandlerService } from './sessionHandler.service';
import { RouteContextProvider } from './routeContextProvider.service';
declare const initiPageInfo: any;
declare const applicationCreated: any;
declare const vehicleDetailsSubmit: any;
declare const backButton: any;
declare const previousPolicyDetailsSubmit: any;
declare const planListingDisplayed: any;
declare const refinement: any;
declare const detailsEdit: any;
declare const quoteCreated: any;
declare const additonalPolicyDetailsCreated: any;
declare const vehicleOwnerDetailsCreated: any;
declare const addressDetailsCreated: any;
declare const paymentStarted: any;
declare const paymentCompleted: any;
declare const paymentFailed: any;
declare const policyBookingStarted: any;
declare const policyIssued: any;
declare const exploreMoreProducts: any;
declare const crossellProducts: any;
declare const nonSTPJourneyInitiate: any;
declare const triggerAPIFailure: any;
declare const applicationResumeStart: any;
declare const applicationResumeCompleted: any;
@Injectable({
  providedIn: 'root'
})
export class adobe_analytics_service {
  private isbfljourney;
  private vehicleType: any;
  private insuranceType = { TWGI: 'Two Wheeler Motor Insurance', FWGI: 'Four Wheeler Motor Insurance' };
  constructor(private _sessionHandlerService: SessionHandlerService,
    private _routeContextProvider: RouteContextProvider) {
    this.vehicleType = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.InsProductType);
    let url: any = window.location.pathname;
    url = url.split('/');
    this.isbfljourney = url.includes(CommonConstants.QueryParamsKeys.marketplace);
  }
  public initiPageInfo() {
    let url: any = window.location.pathname;
    url = url.split('/');
    // const InsProductType = url.includes('car-insurance') ? 'FWGI' : url.includes('two-wheeler-insurance')
    //   ? 'TWGI' : url.includes('taxi-car-insurance-calculator') ? 'TXGI' : 'CVGI';
    const InsProductType = 'FWGI';
    this.vehicleType = this.vehicleType ? this.vehicleType : InsProductType;
    if (!this.isbfljourney) {
      initiPageInfo('insurance', this.insuranceType[this.vehicleType], 'open arch:motor insurance', this.vehicleType, this.insuranceType[this.vehicleType], '')
    }
  }
  public applicationCreated(appId, mob, dob, vehicleRegNo, appQuoteCriteriaID, vehicleRegId, dataSource, processId, nextTaskKey, stagePercentage) {
    if (!this.isbfljourney) {
      applicationCreated(appId, mob, dob, vehicleRegNo, appQuoteCriteriaID, vehicleRegId, dataSource, processId, nextTaskKey, stagePercentage);
    }
  }
  public vehicleDetailsSubmit(vehicleRegId, rtoLocation, vehicleMakeModel, vehicleVariant, vehicleFuelType, registrationMonthYear, ManufacturingYear, processId, nextTaskKey, stagePercentage) {
    const quoteID = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.BuyNowQuoteId);
    const applicantKey = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.LoanApplicationId);
    if (!this.isbfljourney) {
      vehicleDetailsSubmit(applicantKey, quoteID, vehicleRegId, rtoLocation, vehicleMakeModel, vehicleVariant, vehicleFuelType, registrationMonthYear, ManufacturingYear, processId, nextTaskKey, stagePercentage);
    }
  }
  public backButton(stageWhereBackInitiated, nextTaskKey, stagePercentage) {
    const applicantKey = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.LoanApplicationId);
    if (!this.isbfljourney) {
      backButton(applicantKey, stageWhereBackInitiated, nextTaskKey, stagePercentage);
    }
  }
  public previousPolicyDetailsSubmit(prevPolicyDetId, prevPolicytype, prevPolicyClaimed, prevPolicyExpiryDate, processId, nextTaskKey, stagePercentage) {
    const quoteID = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.BuyNowQuoteId);
    const applicantKey = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.LoanApplicationId);
    if (!this.isbfljourney) {
      previousPolicyDetailsSubmit(applicantKey, quoteID, prevPolicyDetId, prevPolicytype, prevPolicyClaimed, prevPolicyExpiryDate, processId, nextTaskKey, stagePercentage);
    }
  }
  public planListingDisplayed(planList, selectedAddOns, emiCardEligibility, processId, nextTaskKey, stagePercentage) {
    const quoteID = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.BuyNowQuoteId);
    const applicantKey = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.LoanApplicationId);
    const quoteIds = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.PlanQuoteIds);
    if (!this.isbfljourney) {
      planListingDisplayed(applicantKey, quoteID, quoteIds, planList, selectedAddOns, emiCardEligibility, processId, nextTaskKey, stagePercentage);
    }
  }
  public refinement(selectedAddOns, planList, changeType, changePosition) {
    const applicantKey = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.LoanApplicationId);
    const quoteID = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.BuyNowQuoteId);
    if (!this.isbfljourney) {
      refinement(applicantKey, selectedAddOns, planList, quoteID, changeType, changePosition);
    }
  }
  public detailsEdit(detailsEditType, stageWhereEditInitiated, nextTaskKey) {
    const applicantKey = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.LoanApplicationId);
    if (!this.isbfljourney) {
      detailsEdit(applicantKey, detailsEditType, stageWhereEditInitiated, nextTaskKey);
    }
  }
  public quoteCreated(varientName, varientCode, riderName, riderCode, principalName, planDescription, policyType, premiumAmount, tenure, processId, nextTaskKey, stagePercentage) {
    const applicantKey = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.LoanApplicationId);
    const quoteID = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.BuyNowQuoteId);
    if (!this.isbfljourney) {
      quoteCreated(applicantKey, quoteID, varientName, varientCode, riderName, riderCode, principalName, planDescription, policyType, premiumAmount, tenure, processId, nextTaskKey, stagePercentage);
    }
  }
  public additonalPolicyDetailsCreated(payload, processId, nextTaskKey, stagePercentage) {
    const applicantKey = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.LoanApplicationId);
    const quoteID = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.BuyNowQuoteId);
    const vehicleFinancedFlg = payload.vehicleFinancedFlg === 1 ? true : false;
    if (!this.isbfljourney) {
      additonalPolicyDetailsCreated(applicantKey, quoteID, payload.vehicleRegId, payload.engineNo, payload.chassisNo,
        payload.policyNo, payload.insuranceProviderId, vehicleFinancedFlg, processId, nextTaskKey, stagePercentage);
    }
  }
  public vehicleOwnerDetailsCreated(payload, processId, nextTaskKey, stagePercentage) {
    const applicantKey = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.LoanApplicationId);
    const quoteID = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.BuyNowQuoteId);
    if (!this.isbfljourney) {
      vehicleOwnerDetailsCreated(applicantKey, quoteID, payload.firstName, payload.lastName, payload.emailId, payload.dateOfBirth,
        payload.mobileNo, processId, nextTaskKey, stagePercentage);
    }
  }
  public addressDetailsCreated(payload, city, state, processId, nextTaskKey, stagePercentage) {
    const applicantKey = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.LoanApplicationId);
    const quoteID = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.BuyNowQuoteId);
    if (!this.isbfljourney) {
      addressDetailsCreated(applicantKey, quoteID, payload.addressId, 'permanentAddress', payload.address1, payload.address2,
        payload.pinCode, city, state, true, processId, nextTaskKey, stagePercentage);
    }
  }
  public paymentStarted(paymentInstrument, systemPaymentId, processId, nextTaskKey, stagePercentage) {
    const applicantKey = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.LoanApplicationId);
    const quoteID = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.BuyNowQuoteId);
    if (!this.isbfljourney) {
      paymentStarted(applicantKey, quoteID, true, paymentInstrument, systemPaymentId, processId, nextTaskKey, stagePercentage);
    }
  }
  public paymentCompleted(applicantId, paymentInstrument, systemPaymentId, referenceNumber, orderId, paymentId, orderAmount, gstAmount, processId, nextTaskKey, stagePercentage) {
    const applicantKey = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.LoanApplicationId);
    const quoteID = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.BuyNowQuoteId);
    if (!this.isbfljourney) {
      paymentCompleted(applicantKey, applicantId, quoteID, true, paymentInstrument, systemPaymentId, referenceNumber, orderId, paymentId, orderAmount, gstAmount, processId, nextTaskKey, stagePercentage);
    }
  }
  public paymentFailed(rejectReason, paymentInstrument, nextTaskKey, stagePercentage) {
    const applicantKey = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.LoanApplicationId);
    const quoteID = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.BuyNowQuoteId);
    if (!this.isbfljourney) {
      paymentFailed(applicantKey, quoteID, rejectReason, paymentInstrument, this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.processId), nextTaskKey, stagePercentage);
    }
  }
  public policyBookingStarted() {
    const applicantKey = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.LoanApplicationId);
    const quoteID = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.BuyNowQuoteId);
    if (!this.isbfljourney) {
      policyBookingStarted(applicantKey, quoteID, this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.processId), 'insPolicyPage', '');
    }
  }
  public policyIssued(policyNo, policyType) {
    const applicantKey = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.LoanApplicationId);
    const quoteID = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.BuyNowQuoteId);
    if (!this.isbfljourney) {
      policyIssued(applicantKey, quoteID, 'policyIssued', '', policyNo, policyType, this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.processId), 'insPolicyPage', '');
    }
  }
  public exploreMoreProducts(currentStage, destinationURL) {
    const applicantKey = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.LoanApplicationId);
    const quoteID = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.BuyNowQuoteId);
    if (!this.isbfljourney) {
      exploreMoreProducts(applicantKey, quoteID, currentStage, destinationURL);
    }
  }
  public crossellProducts(currentStage, productCode, productName, bannerName, bannerPosition, bannerDiscription, destinationURL) {
    const applicantKey = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.LoanApplicationId);
    const quoteID = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.BuyNowQuoteId);
    if (!this.isbfljourney) {
      crossellProducts(applicantKey, quoteID, currentStage, productCode, productName, bannerName, bannerPosition, bannerDiscription, destinationURL);
    }
  }
  public nonSTPJourneyInitiate(mobileNo, dob, vehicleRegNo) {
    if (!this.isbfljourney) {
      nonSTPJourneyInitiate(mobileNo, dob, vehicleRegNo);
    }
  }
  private triggerAPIFailure(errorCode, errorName, apiName) {
    if (!this.isbfljourney) {
      triggerAPIFailure(errorCode, errorName, apiName);
    }
  }
  public applicationResumeStart(mobileNo, dob, vehicleRegNo, appQuoteCriteriaID, vehicleRegId, vehicleMakeModel, vehicleVariant, applicantId, dataSource, nextTaskKey, stagePercentage) {
    if (!this.isbfljourney) {
      const applicantKey = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId);
      applicationResumeStart(applicantKey, mobileNo, dob, vehicleRegNo, appQuoteCriteriaID, vehicleRegId, vehicleMakeModel, vehicleVariant, applicantId, dataSource, this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.processId), nextTaskKey, stagePercentage);
    }
  }
  public applicationResumeCompleted(applicantKey, mobileNo, dob, vehicleRegNo, appQuoteCriteriaID, vehicleRegId, dataSource, resumeWithOTP, nextTaskKey, stagePercentage, vehicleMakeModel, vehicleVariant, applicantId, varientCode, varientName) {
    if (!this.isbfljourney) {
      applicationResumeCompleted(applicantKey, mobileNo, dob, vehicleRegNo, appQuoteCriteriaID, vehicleRegId, dataSource, resumeWithOTP, this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.processId), nextTaskKey, stagePercentage, vehicleMakeModel, vehicleVariant, applicantId, varientCode, varientName);
    }
  }
  public triggerAPIFailureService(payload, serviceName) {
    if (!this.isbfljourney) {
      if (payload.errorBean) {
        this.triggerAPIFailure(payload.errorBean[0].errorCode, payload.errorBean[0].errorMessage, serviceName);
      } else if (payload.length && payload[0].errorCode) {
        this.triggerAPIFailure(payload[0].errorCode, payload[0].errorMessage, serviceName);
      }
    }
  }
}
